export default __webpack_public_path__ + "images/onboarding/splashverse-onboarding-ela-4e9419918cd78e45df497629e904843e.png";